import { PawPrint } from "lucide-react";

const ITEMS = [
  "Rações Premium",
  "Atendimento Especializado",
  "Banho & Tosa",
  "Suprimentos Agrícolas",
  "Entrega Rápida na Região",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-linen bg-linen/40 py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-xl italic text-olive/80 sm:text-2xl">{item}</span>
                <PawPrint className="h-5 w-5 text-clay/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
